export enum ButtonId {
    USER_ADD_PERMISSION_BUTTON = "USER_ADD_PERMISSION_BUTTON",
    USER_UPDATE_PERMISSION_BUTTON = "USER_UPDATE_PERMISSION_BUTTON",
    USER_DELETE_PERMISSION_BUTTON = "USER_DELETE_PERMISSION_BUTTON",
}
